<template>
  <a v-if="value" :href="link" class="icon-text" :target="newTab ? '_blank' : ''">
    <IconComponent :name="icon" class="icon--thick" />
    <span class="icon-text__info">
      <span v-if="title" class="icon-text__title">
        {{ title }}
      </span>
      <span v-if="value" class="icon-text__value" :class="{ 'icon-text__value--big': big }">
        {{ value }}
      </span>
    </span>
  </a>
</template>

<script>
import IconComponent from "components/IconComponent.vue";

export default {
  name: "IconAndTextComponent",
  props: {
    icon: String,
    title: String,
    value: String,
    link: String,
    big: Boolean,
    newTab: Boolean,
  },
  components: { IconComponent },
};
</script>

<style lang="stylus">
.icon-text {
  flex-shrink 0
  display flex
  align-items flex-end
  gap 5px
  color: var(--black)

  .icon {
    margin-bottom 3px
    width: 18px
    height: 18px
  }

  &__info {
    display flex
    flex-direction column
    gap 3px
  }

  &__title {
    font-size: 0.625em
    line-height: 1.1
  }

  &__value {
    font-style: normal;
    font-weight: 700;
    line-height: 145%;

    &--big {
      font-size: 1.375em
      line-height: 1.135
    }
  }
}
</style>
